import React from "react";
import { Link } from "react-router-dom";

const SuccessPage = () => {
  return (
    <div
      className="success-page"
      style={{ textAlign: "center", padding: "50px" }}
    >
      <h1>✅ Hvala na porudžbini!</h1>
      <p>Vaša porudžbina je uspešno kreirana.</p>
      <Link to="/" style={{ color: "#1976d2", textDecoration: "none" }}>
        Povratak na početnu stranicu
      </Link>
    </div>
  );
};

export default SuccessPage;
